import { CSSProperties, ReactElement, ReactNode } from 'react';
import { Box } from '@/lib/mui';

const flexCenterStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
};

export default function FixedLayout({
  children,
  headerContent = <></>,
  bottomContent = <></>,
  footer = <></>,
}: {
  children: ReactNode;
  headerContent?: ReactElement;
  bottomContent?: ReactElement;
  footer?: ReactElement;
  style?: CSSProperties;
}) {
  return (
    <>
      <Box
        style={{
          overflow: 'hidden',
          height: '100dvh',
          background:
            'linear-gradient(180deg, #0096D4 0%, #0096D4 5%, #7537FF 35% 49.99%, #F8FBFE 50%)',
          ...flexCenterStyle,
        }}
      >
        <Box
          sx={{
            height: '45dvh',
            display: 'flex',
            width: '100% ',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          {headerContent}
        </Box>
        <Box
          style={{
            flex: '1 1 0',
            position: 'relative',
            ...flexCenterStyle,
          }}
        >
          <Box
            padding={{ xs: 2, sm: 5 }}
            width={{ xs: 'calc(100% - 2rem)', sm: 'calc(100% - 4rem)' }}
            style={{
              maxWidth: '550px',
              minHeight: 200,
              borderRadius: 20,
              background: '#FFF',
              boxShadow: '0px 4px 14px 0px rgba(0, 0, 0, 0.05)',
            }}
          >
            {children}
          </Box>
          <Box mt={1}>{bottomContent}</Box>
          <Box sx={{ margin: 'auto auto 1rem' }}>{footer}</Box>
        </Box>
      </Box>
    </>
  );
}
